<template>
  <div class="bottom_tree_table">
    <div class="bottom_left">
      <major-tree @detailBtn="detailBtn"></major-tree>
    </div>
    <div class="bottom_right">
      <div class="right_table">
        <el-table :data="personTable" border highlight-current-row style="height: 100%" height="100%">
          <template slot="empty">
            <img :src="zanwu" alt="" />
            <p style="font-size: 16px; color: #000; margin-top: 36px">
              暂无数据
            </p>
          </template>
          <el-table-column label="图层名" prop="layerName" min-width="200px" />
          <el-table-column label="线型" prop="lineType" min-width="120px" />
          <el-table-column label="线宽" prop="lineWeight" min-width="80px" />
          <el-table-column label="颜色" prop="colour" min-width="50px" />
          <el-table-column label="打印样式" prop="plotStyle" min-width="150px" />
          <el-table-column label="是否锁定" min-width="80px">
            <template #default="{ row }">
              <el-checkbox v-model="row.isLocked" :true-label="1" :false-label="0" disabled />
            </template>
          </el-table-column>
          <el-table-column label="是否冻结" min-width="80px">
            <template #default="{ row }">
              <el-checkbox v-model="row.isFrozen" :true-label="1" :false-label="0" disabled />
            </template>
          </el-table-column>
          <el-table-column label="是否关闭" min-width="80px">
            <template #default="{ row }">
              <el-checkbox v-model="row.isOff" :true-label="1" :false-label="0" disabled />
            </template>
          </el-table-column>
          <el-table-column label="是否打印" min-width="80px">
            <template #default="{ row }">
              <el-checkbox v-model="row.isPrint" :true-label="1" :false-label="0" disabled />
            </template>
          </el-table-column>
          <el-table-column label="备注" prop="remark" min-width="180px" />
        </el-table>
      </div>
      <page :page="page" class="page-2" @handleSizeChange="handleSizeChange" @handleCurrentChange="fetchData"></page>
    </div>
  </div>
</template>
<script>
import standardLayer from "@/CommonDP/service/standardLayer-service";
import majorTree from "@/CommonDP/components/structure/majorTree.vue";
import { getEnterpriseId } from "@/CommonDP/utils/auth";
import page from "@/CommonDP/components/paging";
export default {
  components: { page, majorTree },
  data() {
    return {
      zanwu: require("@/CommonDP/assets/暂无数据.png"),
      page: {
        pageNum: 1,
        pageSize: 20,
        totalCount: 0
      },
      personTable: [],
      tuijianIcon: require("@/CommonDP/assets/doc/folder_icon.png"),
      majorID: undefined,
      layerID: undefined
    };
  },
  computed: {
    enterpriseId() {
      return getEnterpriseId("enterpriseId");
    }
  },

  methods: {
    detailBtn(val) {
      this.majorID = val.specId;
      this.categories(val.specId, 1);
    },
    fetchData(val) {
      this.categories(this.majorID, val);
    },
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.categories(this.majorID, 1);
    },
    // 获取图层
    async categories(item, index) {
      this.layerID = undefined;
      const params = {
        dicCode: item,
        pageNum: index,
        pageSize: this.page.pageSize,
        enterpriseId: this.enterpriseId
      };
      const res = await standardLayer.categoriesList(params);
      this.personTable = res.data || [];
      this.page.pageNum = res.pageIndex;
      this.page.totalCount = res.totalCount;
    }
  }
};
</script>
<style lang="scss" scoped>
$top-button-height: 42px;
$middle-height: 30px;
$left-width: 256px;
.bottom_tree_table {
  width: 100%;
  height: 100%;
  background-color: #fff;
  position: relative;
  .bottom_left {
    position: absolute;
    top: 10px;
    bottom: 0;
    left: 10px;
    width: $left-width;
    border-right: 1px solid #ebefff;
    .left_tree {
      overflow: auto;
      position: absolute;
      left: 0;
      top: 10px;
      bottom: 10px;
      right: 0;
      li {
        display: flex;
        border-bottom: 0;
        align-items: center;
        padding: 2px 30px;
        cursor: pointer;
        font-size: 14px;
        line-height: 26px;
        color: var(--key-color);
        img {
          margin-right: 8px;
        }
      }
    }
    .active {
      background: rgba(85, 132, 255, 0.1);
    }
  }
  .bottom_right {
    position: relative;
    height: 100%;
    margin-left: $left-width + 20px;
    .right_button {
      height: $top-button-height;
      padding: 10px;
    }
    .right_table {
      position: absolute;
      top: $top-button-height + 10px;
      left: 10px;
      bottom: 40px;
      right: 20px;
    }
  }
}
.page-2 {
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
  margin: auto 0 0;
  height: 34px;
  padding: 2px;
}

/deep/.el-tree-node__content {
  height: 31px;
  line-height: 31px;
}
/deep/.el-divider--horizontal {
  margin: 10px 0;
}
</style>
